import { z } from 'zod'

import {
	DOCUMENT_LIBRARY_SYSTEM_OPTIONS,
	DOCUMENT_SCOPE_OPTIONS,
} from '#app/routes/mocra+/_form+/intake-options.ts'

export const DocumentLibrarySchema = z.object({
	system: z.enum(
		DOCUMENT_LIBRARY_SYSTEM_OPTIONS.map((option) => option.value) as [
			(typeof DOCUMENT_LIBRARY_SYSTEM_OPTIONS)[number]['value'],
			...string[],
		],
	),
	scope: z.enum(
		DOCUMENT_SCOPE_OPTIONS.map((option) => option.value) as [
			(typeof DOCUMENT_SCOPE_OPTIONS)[number]['value'],
			...string[],
		],
	),
	location: z
		.string({
			required_error: 'Provide the folder path or link.',
		})
		.min(1, 'Provide the folder path or link.'),
})

export type DocumentLibraryEntry = z.infer<typeof DocumentLibrarySchema>
